module.exports = __webpack_public_path__ + "img/gmsyt1.27715bc5.png";